// extracted by mini-css-extract-plugin
export default {"animatedContainer":"AnimatedBox-module__animatedContainer___E0LJq","isGreen":"AnimatedBox-module__isGreen___xsflN","isBlue":"AnimatedBox-module__isBlue___zJBSY"};